<script setup lang="ts">
  import type { IAccordion } from '@/storyblok/content/Content.types'

  withDefaults(defineProps<IAccordion>(), { level2n: false })

  const activeItem = ref()
</script>

<template>
  <UiAccordion
    v-model="activeItem"
    collapsible
  >
    <template
      v-for="item in blok.content"
      :key="item._uid"
    >
      <LazyUiAccordionItem
        :value="`item-${item._uid}`"
        :anchor="item.anchor"
        :level2n="level2n"
      >
        <template #title> {{ item.title }}</template>
        <template #content>
          <template
            v-for="contentItem in item.content"
            :key="`item-content-${contentItem._uid}`"
          >
            <StoryblokComponent
              :blok="contentItem"
              :level2n="!level2n"
            />
          </template>
        </template>
      </LazyUiAccordionItem>
    </template>
  </UiAccordion>
</template>
